import { createContext } from "react"

export interface NewsInterface {
  _id: any, 
  title: string,
  content: string,
  images: string[]
}

export const DefaultNewsInterface: NewsInterface = {
  _id: "",
  title: "",
  content: "",
  images: [""],
}

export interface ShowNewsInterface {
  showSuccessMsg: boolean, setShowSuccessMsg: (showSuccessMsg: boolean) => void,
  showAddNewsModal: boolean, setShowAddNewsModal: (showAddNewsModal: boolean) => void,
  showEditNewsModal: boolean, setShowEditNewsModal: (showEditNewsModal: boolean) => void,
  showDeleteNewsModal: boolean, setShowDeleteNewsModal: (showDeleteNewsModal: boolean) => void,
  selectedNews: NewsInterface, setSelectedNews: (selectedNews: NewsInterface) => void,
  selectedModal: string, setSelectedModal: (selectedModal: string) => void,
  showDeleteNewsPhotoModal: boolean, setShowDeleteNewsPhotoModal: (showDeleteNewsPhotoModal: boolean) => void,
  selectedPhoto: string, setSelectedPhoto: (selectedPhoto: string) => void,
}

export const DefaultShowNewsInterface: ShowNewsInterface = {
  showSuccessMsg: false, setShowSuccessMsg: () => {},
  showAddNewsModal: false, setShowAddNewsModal: () => {},
  showEditNewsModal: false, setShowEditNewsModal: () => {},
  showDeleteNewsModal: false, setShowDeleteNewsModal: () => {},
  selectedNews: DefaultNewsInterface, setSelectedNews: () => {},
  selectedModal: "", setSelectedModal: () => {},
  showDeleteNewsPhotoModal: false, setShowDeleteNewsPhotoModal: () => {},
  selectedPhoto: "", setSelectedPhoto: () => {},
}

export const ShowNewsContext = createContext<ShowNewsInterface>(DefaultShowNewsInterface)

export interface FormDataNewsInterface {
  title: string, setTitle: (title: string) => void,
  content: string, setContent: (content: string) => void,
  images: File[] | any, setImages: (images: File[] | any) => void,
}

export const DefaultFormDataNewsInterface: FormDataNewsInterface = {
  title: "", setTitle: () => {},
  content: "", setContent: () => {},
  images: null, setImages: () => {},
}

export const FormDataNewsContext = createContext<FormDataNewsInterface>(DefaultFormDataNewsInterface)

export enum modalType {
  AddModal = "AddModal",
  EditModal = "EditModal",
  DeleteModal = "DeleteModal",
}

export const videoFormatsAllowed = ["mp4", "webm", "ogg", "avi", "mkv", "mov"];
export const imageFormatsAllowed = ["jpg", "jpeg", "png", "gif", "bmp", "svg"];
